import { createSlice } from '@reduxjs/toolkit'
import IUser from '../../../../interface/core/IUser'
import ISliceState from '../../../../interface/core/ISliceState'
import { sliceStateStatus } from '../../../../Core';

import {
    setUserData
    , removeUserData
    , usersView
} from './usersActions'

const initialState: ISliceState = {
  data: undefined,
  status: sliceStateStatus.idle
  
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        .addCase(setUserData, (state, action) => {
          state.data = {} as IUser;
          Object.assign(state.data, action.payload);
        })
        .addCase(removeUserData, (state, action) => {return initialState;})
        .addCase(usersView.fulfilled, (state, action) => {
          state.data = action.payload.data; 
          state.status = sliceStateStatus.fulfilled; 
        })
        .addCase(usersView.pending, (state, action) => {
          state.status = sliceStateStatus.pending;
        })
        .addCase(usersView.rejected, (state, action) => {
          state.status = sliceStateStatus.rejected;
        })
  }
})

export default userSlice.reducer
